import type { InitializeDepositRequest } from './pnpCashier.types';

let lastPayload: InitializeDepositRequest | null = null;

export const pnpRetryStore = {
  set:   (payload: InitializeDepositRequest) => { lastPayload = payload; },
  get:   () => lastPayload,
  clear: () => { lastPayload = null; },
};
